<app-custom-modal>
    <div modal-title>
        <h4 class="modal-title">{{ "introduction.title" | translate }}</h4>
    </div>
    <div modal-body>
        <p>{{ "introduction.sub_title" | translate }}</p>
        <strong>{{ "introduction.whats_to_explore" | translate }}</strong>

        <div style="display: flex; flex-direction: column; gap: 10px; padding: 8px 0 0 0">
            @for (item of [].constructor(5); track $index) {
                @let iconPath = getIconPathByIndex($index);
                <div>
                    <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 2px">
                        @if (iconPath) {
                            <img [src]="iconPath" [alt]="getIconAltTextByIndex($index)" />
                        }
                        <strong>{{ "introduction.item_" + ($index + 1) + "_title" | translate }} </strong>
                    </div>
                    <span [innerHTML]="'introduction.item_' + ($index + 1) + '_desc' | translate"></span>
                </div>
            }
        </div>
    </div>
    <div modal-footer>
        <app-aw-button size="large" (clickEmitter)="modalService.dismissAll()">
            <span button-content>OK</span>
        </app-aw-button>
    </div>
</app-custom-modal>
